<div class="sp-mt-24 sp-pb-16 fs-16px bold schedule-description" [attr.aria-label]="'manage_schedule_description' | localize" tabindex="0">
  {{ "manage_schedule_description" | localize }}
</div>

<ng-container *ngIf="!!checkInNotificationSettings">
  <div class="sp-mt-24" ui-row>
    <div ui-col>
      <div class="fs-16px bold">{{ "manage_schedule_check_in_reminders" | localize }}</div>
      <p class="text-color-gray-9">{{ "manage_schedule_check_in_reminders_description" | localize }}</p>
    </div>
    <ui-toggle
      class="sp-ml-auto"
      [ngModel]="checkInNotificationSettings.enabled"
      [attr.aria-label]="'toggle_checkins_reminders' | localize"
      (ngModelChange)="onToggleCheckInNotifications($event)"
      ui-row
      uiAlign="middle"
      key="manage-reflection-schedule"
      uiType="toggle-text"></ui-toggle>
  </div>

  <div class="sp-mt-24" *ngIf="checkInNotificationSettings.enabled" ui-row uiAlign="middle">
    <div ui-col>{{ "day" | localize | titlecase }}</div>
    <div class="sp-ml-48" ui-col>
      <ui-select
        [attr.aria-label]="(checkInNotificationSettings.day | localize) + ', ' + ('checkins_selected' | localize) + ', ' + ('checkins_select_day_of_the_week' | localize)"
        [ngModel]="checkInNotificationSettings.day"
        (ngModelChange)="onNotificationDayChange($event)">
        <ui-option *ngFor="let day of days" [uiValue]="day" [uiLabel]="day | titlecase"></ui-option>
      </ui-select>
    </div>
  </div>
</ng-container>
